import { FC } from 'react';

import styles from '../../opm-summary-waterfall-erf.module.scss';
import { GridSelectField } from '@app/shared/components/grid-controls/grid-select-field/GridSelectField';
import { SelectOption } from '@app/shared/models/option';
import { OpmFirstLastWaterfallDictionaryDto } from '@app/shared/models/contracts/opm-calculation-results-dto';
import { useLocale } from '@app/core/hooks/useLocale';
import IterationLevelRow from '../instrument-calculations-erf/row-components/IterationLevelRow';

interface SummaryCalculationsHeaderProps {
  opmWaterfall: OpmFirstLastWaterfallDictionaryDto;
  waterfallIterations: number;
  selectedYear: string;
  yearOptions: SelectOption[];
  onYearChange: (value: string) => void;
}

const SummaryCalcuationsHeader: FC<SummaryCalculationsHeaderProps> = ({
  opmWaterfall,
  waterfallIterations,
  selectedYear,
  yearOptions,
  onYearChange,
}): JSX.Element => {
  const { l } = useLocale();
  const handleYearChange: React.ChangeEventHandler<HTMLSelectElement> = (event) => {
    onYearChange(event.target.value);
  };

  return (
    <thead className="table-primary__sticky-section table-primary__sticky-section--table-single-row-header">
      <tr>
        <th
          className={`${styles['options-select']} ${styles['border-cell-bottom']} ${styles['border-cell-right']}`}>
          <GridSelectField
            aria-label={l('_SelectorAriaLabel', { label: l('_Year') })}
            name="yearSelect"
            options={yearOptions}
            data-testid="year-select"
            value={selectedYear}
            onChange={handleYearChange}
          />
        </th>
        <th colSpan={waterfallIterations} className={styles['top-5-header']}>
          {l('_FirstNSimulations', { n: waterfallIterations })}
        </th>
        <th colSpan={waterfallIterations} className={styles['bottom-5-header']}>
          {l('_LastNSimulations', { n: waterfallIterations })}
        </th>
      </tr>
      <IterationLevelRow
        label="_TimeToExit"
        valueKey="exitYears"
        opmWaterfall={opmWaterfall}
        selectedYear={selectedYear}
        waterfallIterations={waterfallIterations}
        className={styles['border-bottom']}
        decimalPoint={2}
      />
    </thead>
  );
};

export default SummaryCalcuationsHeader;
